import React, {Component} from 'react';
import {Home, Common} from '../components';
import InfiniteScroll from 'react-infinite-scroller';

export default class HomeTemplate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openTermsModal: false
        }

        this.handleOpen = () => {
            this.setState({
                openTermsModal: true
            })
        };

        this.handleClose = () => {
            this.setState({
                openTermsModal: false
            })
        };
    }

    render() {
        const userId = this.props.user.userId;
        const list = this.props.questions.list;
        let listItems = [];
        Object.keys(list).map(index => {
            const question = list[index];
            const whichChecked = (question.result && userId in question.result) ? question.result[userId] : "";
            listItems.push(<Home.ListItem id={question.id} value={question} whichChecked={whichChecked} select={this.props.selectAnswer} />)
        });

        return (
            <main>
                <Common.Spacer size={"medium"} quantity={2} />

                <section className="c-section__wrapin" >
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={() => this.props.fetchQuestions()}    // The function to be called on scroll
                        hasMore={this.props.questions.hasMoreLoaded}
                        initialLoad={true}
                        loader={<Common.Loading />}
                    >
                        <div className="c-grid__row" id="question-list">
                            {listItems}
                        </div>
                    </InfiniteScroll>
                </section>

                <Common.Spacer size={"medium"} quantity={1} />

                <div className="l-footer__home">
                    <Home.NewPostButton handleOpen={this.handleOpen} />
                </div>
                <Home.ModalWindow open={this.state.openTermsModal} handleClose={this.handleClose} />

                <Common.Spacer size={"medium"} quantity={1} />
            </main>
        )
    }
}